export const TASK_STATUS = Object.freeze({
  NOT_STARTED:  'not_started',
  IN_PROGRESS:  'in_progress',
  BLOCKED:      'blocked',
  NEEDS_REVIEW: 'needs_review',
  COMPLETE:     'complete'
})

export const TASK_STATUS_LABELS = {
  not_started:  'Not Started',
  in_progress:  'In Progress',
  blocked:      'Blocked',
  needs_review: 'Needs Review',
  complete:     'Complete'
}

export const TASK_STATUS_COLORS = {
  not_started:  '#9e9e9e',
  in_progress:  '#1976d2',
  blocked:      '#f44336',
  needs_review: '#ff9800',
  complete:     '#2e7d32'
}
